import { Styles } from '@monkvision/types';

export const styles: Styles = {
  pill: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px 10px',
    fontSize: 12,
    marginRight: 8,
  },
  count: {
    borderRadius: 200,
    padding: '1px 4px',
    marginLeft: 4,
  },
};
